export default __webpack_public_path__ + "static/team-al-pacifico-0242a5d7fc6398b61eb234ea1df2749e.png";